/**
 * WeekChip primitive (Plan 03-06).
 *
 * Phase 3: "uke 19" ISO-week number chip. Digits rendered in JetBrains Mono
 * `.tnum` (tabular numerics) per UI-SPEC §Typography.
 *
 * Bygger på <Pill> med den nøytrale tonen. De to variantene `default` og
 * `ghost` var begge aliaser for den, og ble fjernet med pigmentnavnene (#161).
 *
 * The `calendar.week.chip` i18n key = "uke {{n}}" renders the label.
 */
import { useTranslation } from 'react-i18next';
import { Pill } from './Pill';

interface WeekChipProps {
  number: number;
}

export function WeekChip({ number }: WeekChipProps) {
  const { t } = useTranslation();
  // calendar.week.chip = 'uke {{n}}'
  const label = t('calendar.week.chip', { n: number });
  return (
    <span data-testid="week-chip">
      <Pill variant="neutral">
        <span className="tnum">{label}</span>
      </Pill>
    </span>
  );
}
